// extracted by mini-css-extract-plugin
export default {"outerClass":"Cashflow_outerClass__eMmuV","header":"Cashflow_header__sh07-","headTag":"Cashflow_headTag__kNsnU","amtTag":"Cashflow_amtTag__d2QDe","center":"Cashflow_center__9Jlam"};